import { api } from "./httpClient";

export const tenantService = {
  list() {
    return api("/v1/tenants").then((res) => res?.content || []);
  },
  get(uuid) {
    return api(`/v1/tenants/${uuid}`);
  },
  save(payload) {
    return api(payload?.uuid ? `/v1/tenants/${payload.uuid}` : "/v1/tenants", {
      method: payload?.uuid ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
  },
  remove(uuid) {
    return api(`/v1/tenants/${uuid}`, { method: "DELETE" });
  },
  restore(uuid) {
    return api(`/v1/tenants/${uuid}/restore`, { method: "POST" });
  },
};
